<!-- @file 隐私声明开关 -->
<template>
  <div class="plv-ia-privacy-switch">
    <div class="plv-ia-privacy-switch__content">
      <div class="plv-flex-row">
        <plv-switch class="pws-vclass-privacy-switch"
                    :value="enable"
                    v-bind="ynSwitchOption"
                    @change="handleEmitEnable($event);" />

        <div v-if="ynToBool(enable)" class="plv-ia-privacy-switch__content__setting plv-flex-row plv-ml-16">
          <plv-button link-btn class="plv-ia-privacy-switch__content__button pws-vclass-privacy-switch__content__button" @click="isShowPrivacyDialog = true">设置详情</plv-button>
          <span class="plv-ia-privacy-switch__content__text" v-html="content"></span>
        </div>
      </div>

      <div class="plv-ia-privacy-switch__content__tips plv-ml-16" v-if="!ynToBool(enable)">
        <plv-icon class="plv-ia-icon-tips" icon="info-circle" />
        <span>{{tips}}</span>
      </div>

      <plv-dialog
        v-model="isShowPrivacyDialog"
        title="设置隐私声明"
        width="560px"
        custom-class="plv-ia-privacy-switch__dialog"
        @open="handleOptionDialog"
      >
        <plv-editor-tinymce
          ref="editor"
          v-model="privacyContent"
          height="200px"
          base-url="https://s1.videocc.net/library/tinymce/v5.10.2"
          :toolbar="toolbar"
          :tinymce-config="{
            menubar: false
          }"
          placeholder="如: 我已阅读并同意《隐私声明》"
        />

        <div class="plv-flex-vh-center plv-pt-20">
          <plv-button class="pws-vclass-privacy-button--primary" size="medium" @click.stop="setPrivacyContent"> 保存 </plv-button>
          <plv-button
            size="medium"
            type="operate"
            class="plv-ml-20 pws-vclass-privacy-button--cancel"
            @click="isShowPrivacyDialog = false"
          >
            取消
          </plv-button>
        </div>
      </plv-dialog>
    </div>
  </div>
</template>

<script>
import '@polyv/polyv-ui/lib-admin/theme/iconfont.css';
import '@polyv/polyv-ui/lib-admin/theme/atom-css.css';

import { Switch, Button, Dialog, Icon, EditorTinymce } from '@polyv/polyv-ui';
import { ynToBool } from '@polyv/utils/src/boolean';

export default {
  components: {
    'plv-switch': Switch,
    'plv-button': Button,
    'plv-dialog': Dialog,
    'plv-icon': Icon,
    'plv-editor-tinymce': EditorTinymce
  },

  props: {
    // 隐私协议是否开启
    enable: {
      type: [String, Boolean],
      default: 'N'
    },
    // 隐私协议内容
    content: {
      type: String,
      default: ''
    },

    tips: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      privacyContent: '',
      isShowPrivacyDialog: false,
      toolbar: ['link'],
    };
  },

  computed: {
    ynSwitchOption() {
      return {
        activeValue: this.enableType === 'string' ? 'Y' : true,
        inactiveValue: this.enableType === 'string' ? 'N' : false
      };
    },

    enableType() {
      return typeof this.enable === 'string' ? 'string' : 'boolean';
    },
  },

  watch: {
    content: {
      immediate: true,
      handler(val) {
        this.privacyContent = val;
      }
    },
    enable: {
      handler(val) {
        if (this.ynToBool(val)) this.isShowPrivacyDialog = true;
      }
    },
  },
  methods: {
    setPrivacyContent() {
      this.$emit('update:content', EditorTinymce.replaceEnter(this.privacyContent));
      this.isShowPrivacyDialog = false;
    },

    handleEmitEnable(value) {
      this.$emit('update:enable', value);
    },

    handleOptionDialog() {
      this.privacyContent = this.content;
    },

    ynToBool(enabled) {
      if (typeof enabled === 'boolean') return enabled;
      return ynToBool(enabled || 'N');
    }
  },
};
</script>
<style lang="scss">
.plv-ia-privacy-switch {
  display: flex;
  align-items: center;
  // padding-top: 12px;

  & > label {
    width: 60px;
    margin-right: 8px;
  }

  & > .plv-ia-privacy-switch__content {
    flex: 1;
  }
}

.plv-ia-privacy-switch__content__tips {
  color: #757575;
  line-height: 20px;
}

.plv-ia-privacy-switch__content {
  display: flex;

  align-items: center;
}

.plv-ia-privacy-switch__content__button {
  width: 60px;
}
.plv-ia-privacy-switch__content__text {
  margin-left: 12px;
  width: 280px;
  word-break: break-all;

  p {
    display: inline;
    overflow: hidden;
    margin: 0;
    margin-top: 1px;

    text-overflow: ellipsis;
  }
}

.plv-ia-privacy-switch__content__setting {
  line-height: 20px;
}

.plv-ia-privacy-switch__preview__tip {
  color: #2196f3;
  cursor: help;
}

.plv-ia-privacy-switch__preview__image {
  width: 448px;
}
</style>
